import React, { FC } from 'react'
import { useCoreLocaleText } from '@moonpig/web-core-locale-text'
import { RecommendationCarousel } from '../../../components/ProductRecommendationCarousel'
import { useLocaleText } from '../../../locale/moreLikeThis.locale'
import type { ProductInfoProduct, SearchCriteria } from '../../../types'
import { useMoreLikeThisQueries } from '../hooks/useMoreLikeThisQueries'
import {
  moreLikeThisTabsConfig,
  type MoreLikeThisTabValue,
} from '../tabs/moreLikeThisTabsConfig'

type Props = {
  searchCriteria: SearchCriteria
  baseProduct: ProductInfoProduct
}

const getVisibleSections = (
  productsBySection: Record<MoreLikeThisTabValue, ProductInfoProduct[]>,
  loading: boolean,
): MoreLikeThisTabValue[] => {
  const sections = moreLikeThisTabsConfig.map(({ value }) => value)

  if (loading) {
    return sections
  }

  return sections.filter(value => productsBySection[value].length > 0)
}

const getListPosition = (
  section: MoreLikeThisTabValue,
  visibleSections: MoreLikeThisTabValue[],
): string => {
  const index = visibleSections.indexOf(section)

  return `${index + 1}/${visibleSections.length}`
}

export const MoreLikeThisCarousels: FC<Props> = ({
  searchCriteria,
  baseProduct,
}) => {
  const localiseText = useLocaleText()
  const localiseCoreText = useCoreLocaleText()
  const { productsBySection, loading } = useMoreLikeThisQueries(
    searchCriteria,
    baseProduct,
  )
  const visibleSections = getVisibleSections(productsBySection, loading)
  const peopleAlsoViewedTitle = localiseCoreText('common.people_also_viewed')
  const moreLikeThisTitle = localiseText('more_like_this.title')
  const moreFromThisRangeTitle = localiseText('more_like_this.tab_same_range')

  return (
    <>
      <RecommendationCarousel
        title={moreLikeThisTitle}
        titleId="more-like-this-carousel-heading"
        products={productsBySection['more-like-this']}
        loading={loading}
        listName={moreLikeThisTitle}
        listPosition={getListPosition('more-like-this', visibleSections)}
      />
      <RecommendationCarousel
        title={moreFromThisRangeTitle}
        titleId="more-from-this-range-carousel-heading"
        products={productsBySection['more-from-this-range']}
        loading={loading}
        listName={moreFromThisRangeTitle}
        listPosition={getListPosition('more-from-this-range', visibleSections)}
      />
      <RecommendationCarousel
        title={peopleAlsoViewedTitle}
        titleId="people-also-viewed-carousel-heading"
        products={productsBySection['people-also-viewed']}
        loading={loading}
        listName={peopleAlsoViewedTitle}
        listPosition={getListPosition('people-also-viewed', visibleSections)}
      />
    </>
  )
}
